import { defineStore } from "pinia";

import { ModuleStatus } from "@/models/ModuleStatus";

import { brandSecurityService } from "@/services";

import { useBrandStore } from "@/stores/brand-store";

import type { BrandSecurityConfiguration } from "@/models/BrandSecurityConfig";

interface State {
  moduleStatus: ModuleStatus;
  config: BrandSecurityConfiguration | undefined;
}

export const useBrandSecurityStore = defineStore("brandSecurity", {
  scope: "global",
  state: (): State => ({ moduleStatus: ModuleStatus.Initial, config: undefined }),
  actions: {
    async load() {
      const { selectedClient, selectedBrand } = useBrandStore();
      if (selectedClient == null || selectedBrand == null) return;

      this.setStatus(ModuleStatus.Loading);

      try {
        const config = await brandSecurityService.getBrandSecurityConfig(selectedClient, selectedBrand);

        this.storeConfig(config);
        this.setStatus(ModuleStatus.Ready);
      } catch (e) {
        console.error("Error loading brand security config");
        if (import.meta.env.MODE !== "test") console.error(e);

        this.setStatus(ModuleStatus.Initial);
      }
    },

    // Mutations
    storeConfig(payload: BrandSecurityConfiguration): void {
      this.config = payload;
    },
    setStatus(moduleStatus: ModuleStatus): void {
      this.moduleStatus = moduleStatus;
    },
  },
});
